module.exports = __webpack_public_path__ + "img/station-hover.861d376c.png";